import { z } from "zod";

export const recommendationFrequencySchema = z.enum(["DAILY", "EVERY_TWO_DAYS", "THREE_PER_WEEK"]);
export type RecommendationFrequency = z.infer<typeof recommendationFrequencySchema>;

export const recommendationPlanFields = {
  frequency: recommendationFrequencySchema.nullable().optional(),
  weekStartsOn: z.number().int().min(0).max(6).nullable().optional(),
  recommendedMinutes: z.number().int().positive().max(2_147_483_647).nullable().optional(),
};

export function validateRecommendationPlan(value: { frequency?: RecommendationFrequency | null; weekStartsOn?: number | null }, context: z.RefinementCtx) {
  if (value.frequency === "THREE_PER_WEEK" ? value.weekStartsOn == null : value.weekStartsOn != null) {
    context.addIssue({ code: "custom", path: ["weekStartsOn"], message: "Bitte nur für das Wochenziel einen Wochenbeginn auswählen." });
  }
}

export interface RecommendationProgress {
  completedCount: number;
  targetCount: number;
  goalMet: boolean;
  nextDueDate: string;
  periodStart: string | null;
  periodEnd: string | null;
}

export interface RecommendationCardData {
  id: string;
  kind: "standard" | "adaptive";
  title: string;
  message: string;
  contentSlug: string;
  status: "ACTIVE" | "PAUSED" | "COMPLETED";
  frequency: RecommendationFrequency | null;
  weekStartsOn: number | null;
  recommendedMinutes: number | null;
  createdAt: string;
  progress: RecommendationProgress | null;
  trackingAvailable: boolean;
}
